// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PBellOutlinedSvg from "@fishx/icons-svg/es/asn/PBellOutlined";
import FishxIcon from '../components/FishxIcon';

var PBellOutlined = function PBellOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PBellOutlinedSvg
  }));
};

PBellOutlined.displayName = 'PBellOutlined';
export default React.forwardRef(PBellOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PBellOutlined.js
// module id = 3240
// module chunks = 0